import './Button.css'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'logout'
  size?: 'sm' | 'md' | 'lg'
  children: React.ReactNode
  as?: React.ElementType
  href?: string
  to?: string
  target?: React.HTMLAttributeAnchorTarget
  rel?: string
}

export default function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  as = 'button',
  href,
  ...props
}: ButtonProps) {
  const baseClassName = `btn btn-${variant} btn-${size} ${className}`

  if (as !== 'button') {
    const Component = as
    return (
      <Component
        {...(href ? { href } : {})}
        className={baseClassName}
        {...props}
      >
        {children}
      </Component>
    )
  }

  return (
    <button
      className={baseClassName}
      {...props}
    >
      {children}
    </button>
  )
}

